import { render, staticRenderFns } from "./HomeReviews.vue?vue&type=template&id=64b15b27&"
import script from "./HomeReviews.vue?vue&type=script&lang=js&"
export * from "./HomeReviews.vue?vue&type=script&lang=js&"
import style0 from "./HomeReviews.vue?vue&type=style&index=0&id=64b15b27&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports